import { useQuery } from '@apollo/client';
import {
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../../Types/ObjektVy';
import {
  AktivitetDok,
  AktivitetDokVariables,
} from '../Queries/_QueryTypes/AktivitetDok';
import AktivitetDokQuery from '../Queries/AktivitetDokQuery.gql';
import Documents, {
  getDocumentUrl,
} from '../../../../../../Components/Documents/Documents';
import Logger from '../../../../../../Utils/Logger';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { selectedId } from '../../../../../../Components/MasterDetail/MasterDetailUtils';

const AktivitetDokOkjektVyComp: IObjektVyComp = {
  caption: 'Dokument',
  comp: (props: IBusinessCollectionProps) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, loading, error } = useQuery<
      AktivitetDok,
      AktivitetDokVariables
    >(AktivitetDokQuery, {
      variables: { id: selectedId(props.id) || '' },
      skip: props.id == null,
    });

    const AktivitetDok =
      data?.node?.__typename === 'TEDBOAktivitetDok' ? data?.node : null;

    if (loading) {
      return <EDAvenyProgress />;
    } else if (error) {
      const message = `Fel vid hämtning av dokument: ${error.message}`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (AktivitetDok == null) {
      const message = `Fel vid hämtning av dokument: Hittade inget dokument att visa`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (AktivitetDok.EXTENSION == null) {
      const message = `Fel vid hämtning av dokument: Extension saknas`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (AktivitetDok.BINARDATA == null) {
      const message = `Fel vid hämtning av dokument: Blob ID saknas`;
      Logger.error(message);
      return <p>{message}</p>;
    } else {
      const fileName = AktivitetDok.BESKRIVNING || 'Saknar beskriving';

      return (
        <Documents
          documents={[
            {
              url: getDocumentUrl(AktivitetDok.BINARDATA),
              extension: AktivitetDok.EXTENSION,
              fileName,
            },
          ]}
          imageFullscreenTitle={fileName}
        />
      );
    }
  },
};

export default AktivitetDokOkjektVyComp;
